export const NEW_REQUEST_TYPE = {
  bill: "billCardItem",
  signature: "signatureCardItem",
  scellement: "sealCardItem",
  contact: "contactCardItem",
};
